import {ViewRegistry} from "@lernetz/ts-lib";
import {Route} from "@lernetz/ui-components/src/router/Route";
import {UiModule} from "../core/interface";
import {Infobox, InfoboxView} from "../good-practice/components/article/infobox.component";
import {Quote, QuoteView} from "../good-practice/components/article/quote.component";
import {ToolDetailsController} from "../pages/tools/details/tool-details.view";
import {ToolsPageController} from "../pages/tools/tools.view";

const views = new ViewRegistry();
views.add(Quote, () => new QuoteView());
views.add(Infobox, () => new InfoboxView());

export const ToolModule: UiModule = {
    views,
    routes: [
        new Route({
            name: "tools",
            pattern: "/:lang/tools",
            content: (params, route) => {
                return {
                    view: "ToolsPage",
                    data: new ToolsPageController("")
                };
            },
        }),
        new Route({
            name: "tools-filter",
            pattern: "/:lang/filter/tools/:toolId",
            content: (params, route) => {
                return {
                    view: "ToolsPage",
                    // this fix is not good
                    data: new ToolsPageController(params.toolId)
                };
            },
        }),
        new Route({
            name: "tools-details",
            pattern: "/:lang/tools/:toolId",
            content: (params, route) => {
                const data = new ToolDetailsController()
                data.load(params.toolId);

                return {
                    view: "ToolDetailsPage",
                    data,
                };
            },
        }),
    ]
}

